import { LayoutComponent } from '../layout/layout.component';
import { InjectionToken } from '@angular/core';
import { Error404Component } from './errors/error404/error404.component';
import { Error500Component } from './errors/error500/error500.component';
export const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');
export const routes = [

  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
      { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'campaign', loadChildren: () => import('./campaign/campaign.module').then(m => m.CampaignModule) },
      { path: 'vault', loadChildren: () => import('./vault/vault.module').then(m => m.VaultModule) },
      { path: 'export', loadChildren: () => import('./export/export.module').then(m => m.ExportModule) },
      { path: 'configuration', loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule) },
      { path: 'support', loadChildren: () => import('./support/support.module').then(m => m.SupportModule) }
    ]
  },
  {
    path: 'external-redirect',
    canActivate: [externalUrlProvider],
    component: Error404Component
  },
  // Not lazy-loaded routes
  { path: '404', component: Error404Component },
  { path: '500', component: Error500Component },

  // Not found
  { path: '**', redirectTo: '404' }

];
